import { TaskType } from '@modeso/aumico-lib-cpmm-fe/src/lib/enums/task-type.enum';
import { SchedulePeriod } from '../enums/schedule-period.enum';

export interface WorkflowTaskDto {
    workflowTaskId: string;
    description: string;
    taskType: TaskType;
    sectionId?: string;
    scheduleDay?: number;
    scheduleMonth?: number;
    schedulePeriod?: SchedulePeriod;
}
